module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "profile-orders"
  }, [_c('div', {
    staticClass: "wrapper-btn-back",
    style: (("background-color:" + (_vm.globalColors.primary)))
  }, [_c('button', {
    staticClass: "profile-orders-back",
    on: {
      "click": function($event) {
        _vm.$emit('close-modal')
      }
    }
  }, [_c('img', {
    staticClass: "arrow-back",
    attrs: {
      "src": "/static/img/arrow-back.svg",
      "alt": "ir hacia atras"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bold txt-center title-btn"
  }, [_vm._v("MIS PEDIDOS")])]), _vm._v(" "), _c('div', {
    staticClass: "profile-orders-title mb-2 title-bold",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_vm._v("MIS PEDIDOS")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "order-status-selectable"
  }, [_c('SelectComponent', {
    staticClass: "order-status-selecter",
    style: (("background-color:" + (_vm.globalColors.titulo))),
    attrs: {
      "placeholder": "Estados de pedidos",
      "item-text": "name",
      "item-value": "id",
      "options": _vm.status,
      "value": _vm.currentStatus
    },
    on: {
      "input": _vm.handleTab
    }
  })], 1), _vm._v(" "), _c('responsible-table', {
    staticClass: "responsive-table",
    attrs: {
      "break-point": 950,
      "columns": _vm.columns,
      "rows": _vm.rows
    },
    scopedSlots: _vm._u([{
      key: "row",
      fn: function(ref) {
        var row = ref.row;

        return [_c('td', {
          staticClass: "row cell1"
        }, [_vm._v(_vm._s(row.date))]), _vm._v(" "), _c('td', {
          staticClass: "row cell2"
        }, [(_vm.isMovil) ? _c('span', {
          staticClass: "label-movil"
        }, [_vm._v("Pedido: ")]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t" + _vm._s(row.order) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('td', {
          staticClass: "row cell3"
        }, [(_vm.isMovil) ? _c('span', {
          staticClass: "label-movil"
        }, [_vm._v("Total: ")]) : _vm._e(), _vm._v(_vm._s(row.total) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('td', {
          staticClass: "row cell4"
        }, [_vm._v(_vm._s(row.status))]), _vm._v(" "), _c('td', {
          staticClass: "row cell5"
        }, [_vm._v(_vm._s(row.method))]), _vm._v(" "), _c('td', {
          staticClass: "row cell6"
        }, [(_vm.isMovil) ? _c('span', {
          staticClass: "label-movil"
        }, [_vm._v("Entrega: ")]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t" + _vm._s(row.pickUpName) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('td', {
          staticClass: "row cell7"
        }, [_vm._v(_vm._s(row.orderStatus))]), _vm._v(" "), _c('td', {
          staticClass: "row actions"
        }, [_c('button', {
          staticClass: "btn-table",
          attrs: {
            "title": "Detalle de pedido",
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.detail(row.id)
            }
          }
        }, [_c('img', {
          staticClass: "table-view",
          attrs: {
            "src": _vm.view,
            "alt": "Ver detalle"
          }
        })]), _vm._v(" "), (row.voucher) ? _c('button', {
          staticClass: "btn-table",
          attrs: {
            "title": "Adjuntar constancia",
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.deposit(row.id)
            }
          }
        }, [_c('img', {
          staticClass: "table-view",
          attrs: {
            "src": _vm.upload,
            "alt": "Cargar_constancia_pago"
          }
        })]) : _vm._e()])]
      }
    }])
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f00b02c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/orders.vue
// module id = 1136
// module chunks = 7